import useSWR from "swr";
import { customFetcher } from "../../../utils";
import { useEffect } from "react";
import useUnit from "../../../customHooks/useUnit";

export interface Serial {
    serial: string;
    status: string;
    unit: string;
    holder: string;
    assetTag: string;
    email: string;
    batchId: string;
}

export type SerialsArray = Array<Serial>;

export default function useSerials (id: string | number, type: 'activity' | 'units', refreshIndex: number) {
    const unit = useUnit();
    const key = id ? 
        type === 'activity' ? `/inventory/activity/${id}/units` : `/inventory/items/${id}/units?unit=${unit}` : null;
    
        const {
        data,
        mutate
    } = useSWR(key, customFetcher<SerialsArray>, {
        fallbackData: [],
    });

    useEffect(() => {
        mutate();
    }, [refreshIndex]);
    
    return data;
}